
//const urlServer='http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com'
//const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
import { urlServer } from '../mapboxgl/index.js'
export const getAlertas = async (param) =>{
    try{
        let {nombre,apellidos,institucion,puesto,profesion,correo,sel_pais,sel_estado,comentario,boletin} = param
        let url = `${urlServer}/incendios/apiForm/infoalerta`
        const response = await fetch(url,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            },
            body: `{	
                "nombre": "${nombre.replace('"','')}",	
                "apellidos": "${apellidos.replace('"','')}",	
                "institucion": "${institucion.replace('"','')}",	
                "puesto": "${puesto.replace('"','')}",	
                "profesion": "${profesion.replace('"','')}",	
                "correo": "${correo}",	
                "sel_pais": "${sel_pais.replace('"','')}",	
                "sel_estado": "${sel_estado.replace('"','')}",	
                "comentario": "${comentario.replace('"','')} ${boletin.replace('"','')} -enviado desde SATIF"
                }`
          })
          if (response.status === 200) {
            return await response.json();
          } else {
            throw new Error(response.statusText);
          }
    }catch(err){
        return err
    }
}
export const getContacto = async (param) =>{
    try{
        let url = `${urlServer}/incendios/apiForm/infocontacto`
        let {nombre,institucion,correo,comentario} = param
        var comentario_=comentario.replace("\n"," ");
        const response = await fetch(url,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            },
            body: `{	
                "nombre": "${nombre.replace('"','')}",
                "institucion": "${institucion.replace('"','')}",
                "correo": "${correo}",
                "comentario": "${comentario_.replace('"','')} -enviado desde SATIF"
                }`
          })
          if (response.status === 200) {
            return await response.json();
          } else {
            throw new Error(response.statusText);
          }
    }catch(err){
        return err
    }
}
export const getInfoCampo = async (param) =>{
    try{
        let {
            id,
            estado,
            municipio,
            longitud,
            latitud,
            metodo,
            vegetacion,
            superficial,
            copa,
            subterraneo,
            fechaini,
            fechafin,
            superficie,
            comentarios,
            responsable,
            institucion,
            correo
        } = param

        let url = `${urlServer}/incendios/apiForm/infocampo`
        const response = await fetch(url,{
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            },
            body: `{	
                "identificador": "${id.replace('"','')}",
                "estado": "${estado.replace('"','')}",
                "municipio": "${municipio.replace('"','')}",
                "longitud": "${longitud.replace('"','')}",
                "latitud": "${latitud.replace('"','')}",
                "metodo_cord": "${metodo.replace('"','')}",
                "vegetacion": "${vegetacion.replace('"','')}",
                "tipo_sup": "${superficial}",
                "tipo_copa": "${copa}",
                "tipo_subt": "${subterraneo}",
                "fecha_inicio": "${fechaini.replace('"','')}",
                "fecha_term": "${fechafin.replace('"','')}",
                "sup_afectada": "${superficie.replace('"','')}",
                "comentarios": "${comentarios.replace('"','')} -enviado desde SATIF",
                "responsable": "${responsable.replace('"','')},${correo}",
                "institucion": "${institucion.replace('"','')}"
                }`
          })
          if (response.status === 200) {
            return await response.json();
          } else {
            throw new Error(response.statusText);
          }
        //return await response.json()
    }catch(err){
        console.log(err)
        return err
    }
}
export const getPais = async () =>{
    try{
        let url = `${urlServer}/api/totPais?annio=2022&sensor=modis&pcFiltro=pcalor`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getEstados = async (param) =>{
    try{
        let { id } = param 
        let url = `${urlServer}/api/getEstados?pais=${id}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}